<template>
  <div>
    <label v-if="label" class="select-none flex items-center w-full" :for="id">
        <input :id="id" :name="name" type="radio" :value="value" :disabled="disabled"
          @input="$emit('input', $event.target.value)"
          class="mr-2 rounded-full border-gray-300 bg-white text-shtax-600 shadow-sm focus:border-shtax-300 focus:ring focus:ring-shtax-200 focus:ring-opacity-50 checked:bg-shtax-600 checked:border-transparent hover(:checked):bg-shtax-100 disabled:bg-shtax-100">
        <span class="text-sm">{{ label }}</span>
    </label>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
    emits: ['input'],

    props: {
        id: {
          type: String,
          default() {
            return `cb-${this._uid}`
          },
        },
        name: {
          type: String,
          default() {
            return `radio-${this._uid}`
          },
        },
        checked: {
            type: Boolean,
            default: false,
        },
        value: {
          type: String,
            default: null,
        },
        label: String,
        error: String,
        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        proxyChecked: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit("input", val);
            },
        },
    },
}
</script>